export default "__VITE_ASSET__BqGECn2s__"